const workerListGridConfig = {
    columns: [
        {
            id: 1,
            width: 250,
            selector: 'documentName',
            name: 'Тип документ',
            sequenceNumber: 1,
            type: 'string'
        },
        {
            id: 2,
            width: 250,
            selector: 'startDate',
            name: 'Дата на издаване',
            sequenceNumber: 2,
            type: 'date'
        },
        {
            id: 3,
            width: 250,
            selector: 'endDate',
            name: 'Дата на изтичане',
            sequenceNumber: 3,
            type: 'date'
        }
    ],
    props: {
        headerRowHeight: 50,
        rowHeight: 52,
        tableHeight: 500,
        filterable: false,
        selectableColumn: {
            show: true,
            icon: 'fa fa-file-alt',
            width: 90
        }
    }
};

export default workerListGridConfig;
